import type { Component, Entity2D } from '../../odie';
import { FirecrackerBoxBlockProps } from '../defs/block';
import { blockOptionFromCountColor } from '../util/blockOption';
import {
  FirecrackerBoxBlockView,
  FirecrackerBoxColor,
} from '../views/blocks/FirecrackerBoxBlockView';

export type FirecrackerBoxBlockComponentOptions = {
  props: FirecrackerBoxBlockProps;
  option?: number;
};

/*
 * Firecracker Box block component
 */
export class FirecrackerBoxBlockComponent implements Component {
  public static readonly NAME = 'blockFirecrackerBox';

  public entity!: Entity2D;

  public view!: FirecrackerBoxBlockView;

  public get activeColor(): FirecrackerBoxColor {
    return this.view.color;
  }

  public set activeColor(v: FirecrackerBoxColor) {
    this.view.color = v;
  }

  public get activeCount(): number {
    return this.view.count;
  }

  public set activeCount(v: number) {
    this.view.count = v;
  }

  public init(options: FirecrackerBoxBlockComponentOptions): void {
    // create block view
    this.view = new FirecrackerBoxBlockView(options.props);

    // set initial color
    this.activeColor = (options.props.color as FirecrackerBoxColor) ?? 'green';

    // set initial count
    this.activeCount = options.props.count ?? 7;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    return blockOptionFromCountColor({
      count: this.activeCount,
      color: this.activeColor,
    });
  }

  public async launch(): Promise<void> {
    await this.view.launch();
  }
}
